<template>
  <sidebar
    :addTitle="$t('GradeControl.Equipment.AddNew')"
    :editTitle="$t('GradeControl.Equipment.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
    <div class="p-6" v-if="isSidebarActive">
      <vs-row class="mb-3">
        <vs-col vs-w="12">
           <ValidationProvider :name="$t('GradeControl.Equipment.Code')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.Equipment.Code')"
                :disabled="equipmentId !== 0"
                v-model="equipmentCode"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
           </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="equipmentIsContractual" :disabled="equipmentId !== 0" class="mb-2">{{$t('GradeControl.Contractual')}}</vs-checkbox>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Equipment.Company')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.Equipment.Company')"
                v-model="equipmentCompany"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row> 
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Equipment.Type')" rules="required" v-slot="{ errors }">
              <form-label>{{$t('GradeControl.Equipment.Type')}}</form-label>
              <v-select
                :label="$i18n.locale.startsWith('fr') ? 'nameFr' : 'nameEn'"
                :disabled="equipmentId !== 0"
                :options="equipmentTypes"
                :reduce="type => type.id"
                v-model="equipmentType"
                class="w-full"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('GradeControl.Equipment.Description')}} </form-label>
            <vs-textarea 
            v-model="equipmentDescription" 
            class="w-full"  
            name="equipmentDescription" />
          </vs-col>
        </vs-row> 
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Equipment.Volume')" :rules="`required|decimal|min_value:0|max_value:${$systemUnits.convertVolume(30)}`" v-slot="{ errors }">
              <validated-input
                :label="$systemUnits.getVolumeLabel()"
                v-model="equipmentVolume"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="equipmentIsActive" class="mb-2">{{$t('GradeControl.Equipment.IsActive')}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../../shared/components";
import EquipmentTypeEnum from "../../../EquipmentTypeEnum";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    vSelect,
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar
  },
  data() {
    return {
      equipmentId: 0,
      equipmentCode: "",
      equipmentIsContractual: false,
      equipmentCompany: "",
      equipmentType: EquipmentTypeEnum.Scoop,
      equipmentTypes: EquipmentTypeEnum.definition,
      equipmentDescription: "",
      equipmentVolume: null,
      equipmentVolumeInput: null,
      equipmentIsActive: true
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { equipmentId, code, isContractual, company, type, description, volume, isActive } = JSON.parse(JSON.stringify(this.data));
      this.equipmentId = equipmentId;
      this.equipmentCode = code;
      this.equipmentIsContractual = isContractual;
      this.equipmentCompany = company;
      this.equipmentType = type;
      this.equipmentDescription = description;
      this.equipmentVolume = this.$systemUnits.convertVolume(volume);
      this.equipmentIsActive = isActive;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;

      this.equipmentCode = "";
      this.equipmentId = 0;
      this.equipmentIsContractual = false;
      this.equipmentCompany = "";
      this.equipmentType = EquipmentTypeEnum.Scoop;
      this.equipmentDescription = "";
      this.equipmentVolume = null;
      this.equipmentIsActive = true;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            equipmentId: this.equipmentId,
            code: this.equipmentCode,
            isContractual: this.equipmentIsContractual,
            company: this.equipmentCompany, 
            type: this.equipmentType,
            description : this.equipmentDescription, 
            volume : this.$systemUnits.convertVolumeToMetric(this.equipmentVolume),
            projectId: this.projectId,
            isActive: this.equipmentIsActive
          };

          this.$vs.loading();
          if (this.equipmentId !== null && this.equipmentId > 0) {
            this.$store.dispatch("gradeControl/updateEquipment", obj).then((result) => {
              this.$emit("onEquipmentUpdated", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addEquipment", obj).then((result) => {
              this.$emit("onEquipmentInserted", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
